import React from 'react';
import './HomeVideoSection.css';
import playIcon from './assets/svg/status-play.svg';

function HomeVideoSection() {
  return (
    <section className="home-video-section">
      <div className="video-wrapper">
        <div className="video-frame">
          <div className="video-placeholder">
            <img src={playIcon} alt="Play" className="play-icon" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeVideoSection;
